const mEditionAssetContentsTreeNodeActions = {
  mEditionAssetContentsTreeNodeActions: {
    actions: {
      activationDay: 'Día de Activación',
      createSubContent: 'Crear Subcontenido',
      deleteContent: 'Eliminar',
      editContent: 'Editar Contenido',
      editName: 'Editar Nombre',
      comments: 'Ver Comentarios',
      questions: 'Ver Mensajes'
    }
  }
}

export default mEditionAssetContentsTreeNodeActions
